// components/user/Image.js
import React from "react";
import { useNode } from "@craftjs/core";
import { FormControl, FormLabel, TextField, Slider } from "@material-ui/core";

export const Image = ({
                          src,
                          alt,
                          width,
                          height,
                          borderRadius,
                          margin
                      }) => {
    const { connectors: { connect, drag }, selected, actions: { setProp } } = useNode(
        (node) => ({
            selected: node.events.selected
        })
    );

    return (
        <div
            ref={ref => connect(drag(ref))}
            style={{ margin: `${margin}px` }}
        >
            <img
                src={src || "/api/placeholder/400/300"}
                alt={alt}
                style={{
                    width: `${width}px`,
                    height: `${height}px`,
                    borderRadius: `${borderRadius}px`,
                    objectFit: 'cover'
                }}
            />
            {selected && (
                <div style={{
                    padding: '10px',
                    marginTop: '10px',
                    background: '#f8f9fa',
                    borderRadius: '4px'
                }}>
                    <FormControl fullWidth style={{ marginBottom: '8px' }}>
                        <FormLabel>图片链接</FormLabel>
                        <TextField
                            value={src}
                            onChange={e => setProp(props => props.src = e.target.value)}
                            fullWidth
                            placeholder="输入图片URL"
                        />
                    </FormControl>
                    <FormControl fullWidth style={{ marginBottom: '8px' }}>
                        <FormLabel>替代文本</FormLabel>
                        <TextField
                            value={alt}
                            onChange={e => setProp(props => props.alt = e.target.value)}
                            fullWidth
                        />
                    </FormControl>
                    <FormControl fullWidth style={{ marginBottom: '8px' }}>
                        <FormLabel>宽度 (px)</FormLabel>
                        <Slider
                            value={width}
                            step={10}
                            min={50}
                            max={800}
                            onChange={(_, value) => setProp(props => props.width = value)}
                        />
                    </FormControl>
                    <FormControl fullWidth style={{ marginBottom: '8px' }}>
                        <FormLabel>高度 (px)</FormLabel>
                        <Slider
                            value={height}
                            step={10}
                            min={50}
                            max={600}
                            onChange={(_, value) => setProp(props => props.height = value)}
                        />
                    </FormControl>
                    <FormControl fullWidth style={{ marginBottom: '8px' }}>
                        <FormLabel>圆角 (px)</FormLabel>
                        <Slider
                            value={borderRadius}
                            step={1}
                            min={0}
                            max={40}
                            onChange={(_, value) => setProp(props => props.borderRadius = value)}
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <FormLabel>外边距 (px)</FormLabel>
                        <Slider
                            value={margin}
                            step={1}
                            min={0}
                            max={40}
                            onChange={(_, value) => setProp(props => props.margin = value)}
                        />
                    </FormControl>
                </div>
            )}
        </div>
    );
};

Image.craft = {
    props: {
        src: "",
        alt: "图片",
        width: 320,
        height: 240,
        borderRadius: 0,
        margin: 0
    }
}